import { CompanyType, GetApiCompanyError, useGetCompany } from '@sit/openapi';
import { skipToken, UseQueryOptions } from '@tanstack/react-query';
import { useIsAuthenticated } from '@web/auth/use-is-authenticated';
import { useCurrentEntity } from '@web/hooks/use-current-entity';

export function useGetCurrentCompany<TData = CompanyType>(
  options?: Omit<UseQueryOptions<CompanyType, GetApiCompanyError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) {
  const isAuthenticated = useIsAuthenticated();
  const companyId = useCurrentEntity()?.id;

  return useGetCompany<TData>(
    isAuthenticated && companyId
      ? {
          queryParams: {
            companyId,
          },
        }
      : skipToken,
    options,
  );
}
